import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-07b68af4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "•", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "section-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "•", -1))

import { ref, onMounted } from 'vue'
import { apiRedis } from '@/api/index'
import commons from '@/utils/Common'


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideProfile',
  setup(__props) {

const blogsType = ref<any[]>([])
const isLogin = ref(false)
onMounted(async () => {
  isLogin.value = commons.checkLogin()
  await getBlogsType()
})

const buildTree = (data: any[]) => {
  const map: any = {}
  const roots: any[] = []

  data.forEach(item => {
    map[item.id] = { ...item, children: [] }
  })

  data.forEach(item => {
    if (item.parent_id) {
      map[item.parent_id]?.children.push(map[item.id])
    } else {
      roots.push(map[item.id])
    }
  })

  return roots
}



const getBlogsType = async () => {
  const res: any = await apiRedis("profile-blogs-type")
  const data = JSON.parse(res.data.data)
  
  blogsType.value = buildTree(data)
  console.log('blogsType.value')
  console.log(blogsType.value)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogsType.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "section",
        key: item.id
      }, [
        (item.slug == 'auth' && isLogin.value ==true )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_a_menu, {
                mode: "inline",
                selectable: false,
                class: "custom-menu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: child.id
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createVNode(_component_router_link, {
                          to: child.slug
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]))
          : _createCommentVNode("", true),
        (item.slug != 'auth')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: item.slug
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode(_component_a_menu, {
                mode: "inline",
                selectable: false,
                class: "custom-menu"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: child.id
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_router_link, {
                          to: child.slug
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})